module.exports = __webpack_public_path__ + "img/skenet_bedrar.3f1f1f53.png";